<style lang="less" scoped>
.second{display: flex;flex-direction: column;}
.fujian:hover{cursor: pointer;color:rgb(45, 137, 241);}
.el-pagination {text-align: center;}
.pagination{margin: 40px auto;}
.table {border-collapse: collapse;width: 100%;margin-top: 10px;}
table {border-collapse: collapse;width: 100%;}
tr,td {border: 1px solid #f5eeee;padding: 5px;border-bottom: 1px solid #f5eeee;}
.tr {width: 100%;height: 50px;}
.left{width: 200px;}
tr, td {border: 1px solid #f5eeee;padding: 5px;border-bottom: 1px solid #f5eeee;}
.tr .td {float: left;}
.tr {width: 100%;height: 50px;}
.table {border-collapse: collapse;width: 100%;}
.btnbox {width: 100%;text-align: left;border-bottom: 1px solid #e7e7eb;height: 60px;}
.btnbox .elbtn {margin-top: 10px;}
.el-form-item {float: left;margin-bottom: 0px;}
.el-pagination {text-align: center;}
.el-form table {width: 100%;}
.tr td .el-form-item /deep/.el-form-item__content {margin-right: 10px;}
.type /deep/ .el-input__inner {width: 200px;}
.content /deep/ .el-input__inner {width: 200px;}
.fujian:hover{cursor: pointer;color:rgb(45, 137, 241);}
.pagination{margin-bottom: 40px;margin-top: 40px;}
</style>

<template>
  <div class="second" id="second">
    <div class="dmkclb—_box second">
      <el-form ref="form" :model="form">
        <table class="dmkclb">
          <tr class="tr tr1">
            <td>
              <el-form-item>
                <div class="td">
                  <el-input v-model="form.title" placeholder="请输入报名用户" class="input ziduanKey"></el-input>
                </div>
              </el-form-item>
              <el-form-item>
                <div class="td">
                  <el-button class="elbtn search" @click="search">搜索</el-button>
                  <el-button class="elbtn reset" @click="cancelfnBtn()">重置</el-button>
                </div>
              </el-form-item>
            </td>
          </tr>
        </table>
      </el-form>
      <div class="el-tablebox">
        <el-table
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          @selection-change="handleSelectionChange"
          stripe
          border
          :cell-style="{ textAlign: 'center' }"
          :header-cell-style="{background: '#F5F5F5',color: '#606266',textAlign: 'center'}">
          <el-table-column type="selection" width="50"></el-table-column>
          <el-table-column label="类型">
              <template slot-scope="scope">{{ scope.row.type | typeData() }}</template>
          </el-table-column>
          <el-table-column prop="name" label="报名用户"></el-table-column>
          <el-table-column prop="phone" label="手机号"></el-table-column>
          <el-table-column prop="company" label="公司"></el-table-column>
          <el-table-column prop="nums" label="人数"></el-table-column>
          <el-table-column prop="names" label="会议名称" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="addtime" label="报名时间">
            <template slot-scope="scope">{{ (scope.row.addtime * 1000) | formatTime() }}</template>
          </el-table-column>
          <el-table-column prop="examine" label="审核状态">
            <template slot-scope="scope">
              <span class="shzt">{{ scope.row.examine | examine_datas() }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="reason" label="理由"></el-table-column>
          <el-table-column prop="id" label="操作">
            <template slot-scope="scope">
              <el-button type="danger" @click="deletefn(11, 106, scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="btnbox">
        <el-button class="elbtn delete" @click="deletesfn(11, 106)">批量删除</el-button>
      </div>
    </div>
    <div class="block">
      <el-pagination
        class="pagination"
        @size-change="handleSizeChange(this.form.count)"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="countSum">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import filters from '../../method/filter'
export default {
  mixins: [filters],
  props: ['userdata'],
  data()
  {
    return {
      form: {
        type: 2,
        content: '',
        starttime: '',
        endtime: '',
        iscomments: null,
        count: 10
      },
      user: '',
      rowid: null,
      pageSize: 20,
      currentPage: 1,
      countSum: null,
      // 查看附件图片弹框
      isdialogVisible: false,
      urlShow: '',
      //列表数据
      tableData: [],
      //弹框显隐
      dialogVisible: false,
      widthCSH: '75%'
    }
  },
  created()
  {
    this.user = localStorage.getItem('username')
    this.getList()
  },
  methods: {
    //获取数据
    getList()
    {
      let count = this.form.count
      let currentPage = this.currentPage
      let exp = ''
      //循环筛选条件
      for (let e in this.form)
      {
        let item = this.form[e]
        if (item && e === 'title')
          exp += `A.name like '%${item}%' and `
      }
      exp = exp ? `${exp}A.id != 0 and username = ${this.user}` : `A.id > 0 and username = ${this.user}`
      // (exp)
      let paras = {cmd: 'queryUnion', _major: 11, _minor: 106, tables: 'A;B:11,105', cols: 'A:*;B:name as names', _exp: exp + ' and A.meetingid=B.id', init: 0, pageno: `${currentPage}`, pagesize: `${count}`, orderby: 'id Desc'}
      window.post.getPost(paras).then((ret) =>
      {
        if (ret.length !== 0)
        {
          this.countSum = ret[0].total
          this.tableData = []
          ret[0].data.forEach((item) =>
          {
            this.tableData.push({
              id: item.id,
              type: item.type,
              name: item.name,
              names: item.names,
              phone: item.phone,
              company: item.company,
              nums: item.nums,
              meetingid: item.meetingid,
              addtime: item.addtime,
              examine: item.examine,
              reason: item.reason
            })
          })
        }
      })
    },
    //查看附件
    look(str)
    {
      this.urlShow = str
      this.isdialogVisible = true
    },
    //点击回复
    reply(row)
    {
      this.rowid = row.id
      this.dialogVisible = true
    },
    cancle()
    {
      this.dialogVisible = false
      this.getList()
    },
    search()
    {
      this.getList()
      this.handleSizeChange(20)
    },
    //重置搜索条件
    cancelfnBtn()
    {
      for (let key in this.form)
      {
        if (key === 'type') continue
        if (key === 'count') continue
        this.form[key] = ''
      }
    },
    //当选择项发生变化时会触发该事件
    handleSelectionChange(val)
    {
      let temp = []
      val.forEach((item) => temp.push(item.id))
      this.multipleSelection = temp
    },
    //每页条数
    handleSizeChange(val)
    {
      this.pageSize = val
    },
    //当前页数
    handleCurrentChange(val)
    {
      this.currentPage = val
      this.search()
    },
    /**
     * 彻底删除--单
     * 获取下拉框列表
     * @param {String} major  //主类型
     * @param {String} minor  //子类型
     */
    deletefn(major, minor, row)
    {
      let that = this
      window.public.deletefn(major, minor, row, that)
    },
    /**
     * 彻底删除——多
     * 获取下拉框列表
     * @param {String} major  //主类型
     * @param {String} minor  //子类型
     */
    deletesfn(major, minor)
    {
      let that = this
      window.public.deletesfn(major, minor, that)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/assembly/chxx/Information.vue